import { StoreFinder } from '@/commons/component/store-finder';
import { SlidingPanel } from './../../modules-es5/commons/layout/sliding-panel';

let storePanelIsInited = false;
let storePanel = null;
const isHK = cube.env.country === 'HK';

export function openPanel() {
  if (!storePanelIsInited) initPanel();
  else storePanel.open();
}

const initStoreFinder = () => {
  const storeFinder = new StoreFinder({
    container: cube.$('.dkt-sliding-panel-inner .store-selection'),
    template: 'plp'
  });

  storeFinder.onClick('.store-selection__store-header', ({ element }) => {
    element.parentNode.$$('.store-selection__store-header').forEach(dt => {
      if (dt !== element)
        dt.classList.remove('store-selection__store-header--showed');
    });
    element.classList.toggle('store-selection__store-header--showed');
  });

  storeFinder.onClick('.js-store-selection', ({ store }) => {
    cube.stores
      .setDefaultStore(store.store_id)
      .then(storeSettingajaxSucces);
  });
};

function initPanel() {
  const storeSelectionTemplate = cube.$('.store-selection');
  const panelContentClone = storeSelectionTemplate.cloneNode(true);

  // constuct and update var
  storeSelectionTemplate.parentNode.removeChild(storeSelectionTemplate);

  storePanel = new SlidingPanel();
  storePanel.init({
    content: panelContentClone,
    destroyOnClose: false,
    name: 'store-selection-panel',
    title: isHK ? window.Messages('storeselection.selectYourStore') : window.Messages('storeselection.panelTitle'),
  });

  storePanelIsInited = true;

  initStoreFinder();
}

const storeSettingajaxSucces = () => {
  const storeFilterEnablingSucces = () => {
    const toggler = cube.$('.store-filter__toggle');
    toggler.checked = false;

    $('#product-filters-ajax-reload').FiltersCommonFunctionalitiesPlugin(
      'reloadListingCartridges',
      cube.$('#dkt-select-sort-option').value,
      cube.$('#dkt-select-sort-option').dataset.url
    );
  };

  const storeFilterEnablingUrl =
    'rest/model/com/decathlon/cube/commerce/locations/LocationActor/enableStoreFilter';

  cube.ajax
    .post(storeFilterEnablingUrl, { enableFilter: false })
    .onSuccess(storeFilterEnablingSucces)
    .call();

  storePanel.close();
};



// WEBPACK FOOTER //
// ./src/catalog/product-list/plp-store_selection-finder.js